export function IsProduction() {
    return GetEnvironmentName() === 'PROD';
}

function GetEnvironmentName() {
	// Value is coming from webpack configuration
	const environmentName = ENVIRONMENT_NAME;
	return environmentName;
}

declare var ENVIRONMENT_NAME: string;
